import { render, staticRenderFns } from "./EmployeeEdit.vue?vue&type=template&id=04006c0a&scoped=true&"
import script from "./EmployeeEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04006c0a",
  null
  
)

export default component.exports